import { FormTextCollection } from './FormTextCollection'

export const FormTextCollectionPrintEditor = props => {
  return <FormTextCollection editor {...props} />
}
